<script>
  import Button from './ui/button.svelte'

  // dismissible=false locks the close button, backdrop and Escape (e.g. mid-upload).
  let { open = $bindable(false), title, children, onclose, dismissible = true } = $props()

  const close = () => {
    if (!dismissible) return
    open = false
    onclose?.()
  }

  // An inner control that handled Escape itself (a Combobox closing its list) prevents the
  // default, so the modal stays open.
  const onkeydown = (event) => {
    if (open && event.key === 'Escape' && !event.defaultPrevented) close()
  }
</script>

<svelte:window {onkeydown} />

<dialog class="modal" class:modal-open={open}>
  <div class="modal-box">
    <Button variant="ghost" size="sm" circle icon="close" class="absolute right-2 top-2" aria-label="Close modal" disabled={!dismissible} onclick={close} />

    {#if title}<h3 class="text-lg font-bold mb-4">{title}</h3>{/if}

    {@render children?.()}
  </div>

  <button type="button" class="modal-backdrop" aria-label="Close modal" onclick={close}></button>
</dialog>
